import React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';
import 'swiper/css/mousewheel';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Thumbs, Mousewheel } from 'swiper';
import { SliderContainer, ThumbnailsContainer } from '../styles/Carousel';


export default class Carousel extends React.PureComponent{
    constructor(props){
        super(props);
        this.state = {
            thumbSwiper: null,
            sliderSwiper: null
        }
    }

    updateSlider = (e) => {
        setTimeout(() => {
            this.state.sliderSwiper.update();
            this.state.thumbSwiper.update();
        }, 300);
    }

    addCustomEvents = () => {
        window.addEventListener("orientationchange", this.updateSlider);
    }

    setSliderSwiper = (swiper) => {
        this.setState({
            sliderSwiper: swiper
        });
        this.props.setCarouselSwiper(swiper);
    }

    onThumbSwiper = (thumbSwiper) => {
        this.setState({
            thumbSwiper: thumbSwiper
        });
    }

    prevClick = (e) => {
        this.state.sliderSwiper.slideTo(
            this.state.sliderSwiper.activeIndex-1
        )
    }

    nextClick = (e) => {
        this.state.sliderSwiper.slideTo(
            this.state.sliderSwiper.activeIndex+1
        )
    }

    //Lifecycle methods

    componentDidMount(){
        this.addCustomEvents();
    }

    render(){
        const { thumbSwiper } = this.state;
        const { thumbnailItems, items } = this.props;
        const thumbnailItemsSwiperSlides = thumbnailItems.map((item) => {
            return <SwiperSlide>{item}</SwiperSlide>
        });
        const ItemsSwiperSlides = items.map(item => {
            return <SwiperSlide>{item}</SwiperSlide>
        })
        return (
            <>
                <ThumbnailsContainer className='thumbnailContainer'>
                    <button className='buttonPrev btn btn-default slide-images'>
                        <i class="material-icons">keyboard_arrow_up</i>
                    </button>
                    <Swiper
                        onResize={this.updateSlider}
                        modules={[Mousewheel, Thumbs]} 
                        onSwiper={(swiper) => this.onThumbSwiper(swiper)}
                        direction="vertical"
                        slidesPerView="auto"
                        watchSlidesProgress={true}
                        spaceBetween={10}
                        mousewheel={{forceToAxis: true}}
                    >
                        { thumbnailItemsSwiperSlides }
                    </Swiper>
                    <button className='buttonNext btn btn-default slide-images'>
                        <i class="material-icons">keyboard_arrow_down</i>
                    </button>
                </ThumbnailsContainer>
                <SliderContainer className='sliderContainer'>
                            <div className="buttonPrev">
                                <img src="/img/gallery_arrow.svg"/>
                            </div>
                            <div className="buttonNext">
                                <img src="/img/gallery_arrow.svg"/>
                            </div>
                        
                        <Swiper
                            modules={[Navigation, Pagination, Thumbs]}
                            thumbs={{ swiper: thumbSwiper}}
                            onSwiper={this.setSliderSwiper}
                            pagination={true}
                            breakpoints={{
                                0: {
                                    pagination: {
                                        enabled: true
                                    },
                                    navigation: {
                                        enabled: false
                                    }
                                },
                                768:{
                                    pagination: {
                                        enabled: false
                                    },
                                    navigation: {
                                        enabled: true,
                                        nextEl: ".buttonNext",
                                        prevEl: ".buttonPrev"
                                    }
                                }
                            }}
                            onClick={this.onClickSwiper}
                            onAfterInit={(e) => {
                                let thumbnailContainer = document.querySelector('.thumbnailContainer');
                                let sliderContainer = document.querySelector('.sliderContainer');
                                thumbnailContainer.style.maxHeight = sliderContainer.offsetWidth + "px";
                                this.updateSlider(e);
                            }}
                            onResize={(e) => {
                                let thumbnailContainer = document.querySelector('.thumbnailContainer');
                                let sliderContainer = document.querySelector('.sliderContainer');
                                thumbnailContainer.style.maxHeight = sliderContainer.offsetWidth + "px";
                                this.updateSlider(e);
                            }}
                        >
                            { ItemsSwiperSlides }
                        </Swiper>
                </SliderContainer>
            </>
        )
    }
}